import { render, staticRenderFns } from "./productPurchaseColorMgmt.vue?vue&type=template&id=1e653e58"
import script from "./productPurchaseColorMgmt.vue?vue&type=script&lang=js"
export * from "./productPurchaseColorMgmt.vue?vue&type=script&lang=js"
import style0 from "./productPurchaseColorMgmt.vue?vue&type=style&index=0&id=1e653e58&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports